/**
 * ID Validation Schemas
 */

import { z } from 'zod';

import {
  OPEN_DESTINATION_CODES as _OPEN_DESTINATION_CODES,
  countryCodeSchema as _countryCodeSchema,
  openDestinationCountrySchema as _openDestinationCountrySchema,
} from '../validators';

export const uuidSchema = z.uuid();

export const idParamSchema = z.object({
  id: uuidSchema,
});

export type IdParam = z.infer<typeof idParamSchema>;

export const slugSchema = z
  .string()
  .min(1)
  .max(100)
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Invalid slug format');

/** Re-export from validators (single source of truth for country codes). */
export const countryCodeSchema = _countryCodeSchema;
/** An OPEN destination — see `validators`. */
export const openDestinationCountrySchema = _openDestinationCountrySchema;
export const OPEN_DESTINATION_CODES = _OPEN_DESTINATION_CODES;

export const localeSchema = z.enum(['en', 'pt', 'es', 'de', 'it', 'fr']);

export type SupportedLocale = z.infer<typeof localeSchema>;
